var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$isFlag ? "mainH5" : "mainWeb", attrs: { id: "test" } },
    [
      !_vm.$isFlag
        ? _c("div", { staticClass: "header top" }, [
            _c(
              "div",
              {
                staticClass: "con-wrap",
                style: !_vm.isFlag ? "padding: 0 23%;height:1.6rem" : ""
              },
              [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "title" },
                  _vm._l(
                    ["官网首页", "账号自助管理", "账号中心", "账号注册"],
                    function(item, index) {
                      return _c(
                        "p",
                        {
                          key: index,
                          class:
                            index === _vm.currentIndex ? "active" : "hover",
                          on: {
                            click: function($event) {
                              return _vm.titleClick(index)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(item))])]
                      )
                    }
                  ),
                  0
                ),
                this.$store.state.authLogin.isLogin == "1"
                  ? _c("div", { staticClass: "logout" }, [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            float: "left",
                            "margin-right": "0.2rem"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                this.$store.state.authLogin.userInfo || "XXX"
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c("p", { on: { click: _vm.logout } }, [_vm._v("退出")])
                    ])
                  : _vm._e()
              ]
            )
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "entrance-box",
          style: !_vm.$isFlag ? "background: #f5f7fb;" : "background: #f5f7fb;"
        },
        [
          !_vm.isFlag
            ? _c("div", [
                !_vm.isSelf
                  ? _c("img", {
                      staticStyle: { width: "100%", height: "5.4rem" },
                      attrs: {
                        src: require("assets/images/accountCenter/banner@2x.png"),
                        alt: ""
                      }
                    })
                  : _c("img", {
                      staticStyle: { width: "100%", height: "5.4rem" },
                      attrs: {
                        src: require("assets/images/accountCenter/1090.png"),
                        alt: ""
                      }
                    })
              ])
            : _vm._e(),
          _c("div", { staticClass: "content" }, [
            _c("img", {
              staticClass: "leitingImg",
              attrs: {
                src: require("assets/images/accountCenter/245@2x.png"),
                alt: "",
                srcset: ""
              }
            }),
            _c("div", [_c("router-view")], 1)
          ])
        ]
      ),
      _c("div", {
        staticStyle: { overflow: "auto" },
        attrs: {
          id: "LT_footer",
          "data-key": "gm1",
          "data-tongji": "gm",
          "data-color": "light"
        }
      })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "logo",
        attrs: { href: "//www.leiting.com/mobile/index.html" }
      },
      [
        _vm._v("雷霆游戏 "),
        _c("img", {
          attrs: {
            src: require("assets/images/accountCenter/logo.png"),
            alt: ""
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }